// extracted by mini-css-extract-plugin
export default {"account_wrapper":"ui_account_wrapper__Xs+df"};